module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;
  return (_vm.$route.path !== '/experience') ? _h('nav', {
    staticClass: "nav-bar"
  }, [_h('router-link', {
    staticClass: "link",
    style: ({
      color: _vm.$route.path === '/' ? 'white' : ''
    }),
    attrs: {
      "to": "/"
    }
  }, ["Accueil"]), " ", _h('router-link', {
    staticClass: "link",
    style: ({
      color: _vm.$route.path === '/' ? 'white' : ''
    }),
    attrs: {
      "to": "/experience"
    }
  }, ["Expérience"]), " ", _h('router-link', {
    staticClass: "link",
    style: ({
      color: _vm.$route.path === '/' ? 'white' : ''
    }),
    attrs: {
      "to": "/testimonials"
    }
  }, ["Témoignages"]), " ", _h('router-link', {
    staticClass: "link",
    style: ({
      color: _vm.$route.path === '/' ? 'white' : ''
    }),
    attrs: {
      "to": "/credits"
    }
  }, ["Crédits"])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-ccf7c486!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/NavBar.vue
// module id = 57
// module chunks = 1